import React, { useEffect, useRef, useState } from "react";
import { View, Animated, TouchableOpacity, Text, StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";

const ProfileSegmentedControl = ({
  options,
  value,
  onChange,
  width = "100%",
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [containerWidth, setContainerWidth] = useState(0);
  // value is true for index 0, false for index 1
  const animation = useRef(new Animated.Value(value ? 0 : 1)).current; 

  useEffect(() => {
    Animated.timing(animation, {
      toValue: value ? 0 : 1,
      duration: 200,
      useNativeDriver: false,
    }).start();
  }, [animation, value]);

  const handlePress = (index) => {
    if (disabled) return;
    onChange(index === 0);
  };

  const thumbWidth = containerWidth > 0 ? (containerWidth - 8) / 2 : 0; 

  return (
    <View 
      style={[styles.container, { width }, disabled && styles.containerDisabled]}
      onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
    >
      {containerWidth > 0 && (
        <Animated.View
          style={[
            styles.thumb,
            disabled && styles.thumbDisabled,
            {
              width: thumbWidth,
              transform: [
                {
                  translateX: animation.interpolate({
                    inputRange: [0, 1],
                    outputRange: [4, containerWidth / 2], 
                  }),
                },
              ],
            },
          ]}
        />
      )}
      <View style={styles.buttonsContainer}>
        {options.map((option, index) => {
          const isSelected = (value ? 0 : 1) === index;
          return (
            <TouchableOpacity
              key={option}
              style={styles.button}
              activeOpacity={0.7}
              disabled={disabled}
              onPress={() => handlePress(index)}
            >
              <Text
                style={[
                  Fonts.medium14,
                  {
                    color: disabled
                      ? Colors.grayColor
                      : isSelected
                        ? Colors.blackColor
                        : Colors.grayColor,
                    fontWeight: isSelected ? "600" : "500",
                  },
                ]}
              >
                {t(option)}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 40,
    backgroundColor: Colors.lightGrayColor,
    borderRadius: 14,
    flexDirection: "row",
    position: "relative",
  },
  containerDisabled: {
    opacity: 0.65,
  },
  thumb: {
    position: "absolute",
    top: 4,
    height: 32,
    backgroundColor: Colors.whiteColor,
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
    elevation: 2,
  },
  thumbDisabled: {
    shadowOpacity: 0,
    elevation: 0,
  },
  buttonsContainer: {
    flexDirection: "row",
    width: "100%",
    height: "100%",
    alignItems: "center",
  },
  button: {
    flex: 1,
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
});

export default ProfileSegmentedControl;
